/**
 * Created by Hp on 16/05/2017.
 */
(function () {

    'use strict';

    var stockDocActions = {
        controller: stockDocActionsCtrl,
        controllerAs: "vm",
        bindings: {
            handleRemove: "=remove",
            prePrint: "=prePrint",
            handleSave: "=handleSave",
            validate: "=validate",
            invalidate: "=invalidate",
            stockDocument: "=ngModel",
            documentType: "=documentType",
        },
        template: require('stock/views/stock-doc-actions.tpl.html'),

    };

    stockDocActionsCtrl.$inject = ["$element", "$attrs", "$translate", "$scope", "stockService", "$mdDialog", "configService", "articleService", "$mdToast"];

    function stockDocActionsCtrl($element, attrs, $translate, $scope, stockService, $mdDialog, configService, articleService, $mdToast) {

        var vm = this;
        vm.$onInit = init;
        vm.cancel = goBack;
        vm.handleSubmit = handleSubmit;
        vm.removeDocument = removeDocument;
        vm.handleInvalidate = handleInvalidate;
        vm.handleValidate = handleValidate;
        vm.handleConfirm = handleConfirm;
        vm.handleAnswers = handleAnswers;
        vm.printCodes = printCodes;
        var documentCls = !_.isUndefined(attrs['documentCls']) ? attrs['documentCls'] : null;
        var docPackage = !_.isUndefined(attrs['package']) ? attrs['package'] : null;
        vm.printGroup =   !_.isUndefined(attrs['printGroup']) ? attrs['printGroup'] : null;
        vm.addButton = attrs['documentCls'] == 'PriceRequest' ? true : false

        function init() {
            vm.allow_stock_doc_confirm = false;
            vm.promise = configService.get('store_config')
                .then(data => {
                    vm.allow_stock_doc_confirm = _.get(data, 'allow_stock_doc_confirm', false);
                });
        }

        function handleSubmit(with_exit) {
            vm.handleSave['action'](with_exit);
        }

        function removeDocument() {
            $mdDialog.show(
                $mdDialog.confirm()
                    .parent($(document.body))
                    .clickOutsideToClose(true)
                    .title('')
                    .textContent($translate.instant('delete_warning'))
                    .ariaLabel('delete_warning')
                    .ok($translate.instant('confirm'))
                    .cancel($translate.instant('cancel'))
            ).then(function () {
                if (!vm.prevent_remove) {
                    vm.prevent_remove = true;
                    vm.promise = stockService.deleteStockObject(vm.stockDocument.id, vm.handleRemove['viewName']).then(success);
                }
            });

            function success(data) {
                goBack();
            }
        }

        function goBack() {
            window.history.back();
        }

        function handleInvalidate() {
            if (!vm.prevent_invalidate) {
                $mdDialog.show(
                    $mdDialog.confirm()
                        .parent($(document.body))
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant('invalidate_warning'))
                        .ariaLabel('invalidate_warning')
                        .ok('Ok')
                        .cancel('No')
                ).then(function () {
                    startInvalidate();
                });
            }

        }

        function startInvalidate() {
            vm.prevent_invalidate = true;
            vm.promise = vm.invalidate.action().then(refresh);


            function refresh(data) {
                if (data) {
                    vm.prevent_invalidate = false;
                    vm.stockDocument = data;
                    if (_.get(vm.validate, 'saveSuccess')) {
                        vm.validate.saveSuccess(data);
                    }
                } else {
                    stockService.getIssuedInvalidateDetail(vm.stockDocument.id, documentCls, vm.documentType).then(res => {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent($(document.body))
                                .clickOutsideToClose(true)
                                .title('')
                                .htmlContent(res['base_invalidate']  ?  $translate.instant(res['base_invalidate']) :`${$translate.instant('document_invalidate_impossible')} <br\>
                                      <ul>
                                       <li><strong>${$translate.instant('unavailable_qte_codes')}: </strong> ${res['unavailable_qte_codes']} </li><br\>
                                       <li><strong>${$translate.instant('unavailable_serials')}: </strong> ${res['unavailable_serials']}</li><br\>      
                                       <li><strong>${$translate.instant('unavailable_lots')}:   </strong>${res['unavailable_lots']}</li> 
                                       </ul>                                    
                                `)
                                .ariaLabel('document_invalidate_impossible')
                                .ok('Ok')
                        );
                    })
                    vm.prevent_invalidate = false;
                }
            }
        }

        function handleValidate() {
            if (!vm.prevent_validate) {
                $mdDialog.show(
                    $mdDialog.confirm()
                        .parent($(document.body))
                        .clickOutsideToClose(true)
                        .title('')
                        .textContent($translate.instant('validate_warning'))
                        .ariaLabel('validate_warning')
                        .ok('Ok')
                        .cancel('No')
                ).then(function () {
                    vm.prevent_validate = true;
                    vm.prePrint().then(success);
                });
            }

            function success(res) {
                vm.promise = vm.validate.action(res).then(refreshData);
            }

            function refreshData(data) {
                if (data) {
                    vm.stockDocument = data;
                    vm.prevent_validate = false;
                    if (_.get(vm.validate, 'saveSuccess')) {
                        vm.validate.saveSuccess(data);
                    }
                } else {
                    $mdDialog.show(
                        $mdDialog.alert()
                            .parent($(document.body))
                            .clickOutsideToClose(true)
                            .title('')
                            .textContent($translate.instant('document_validate_impossible'))
                            .ariaLabel('document_validate_impossible')
                            .ok('Ok')
                    );
                    vm.prevent_validate = false;

                }
            }
        }

        function handleConfirm() {
            vm.stockDocument.is_confirmed = true;
            handleSubmit(false);
        }

        function handleAnswers(ev) {
            $mdDialog.show(_.assign(require('stock/dialogs/price-request-response-dialog'), {
                targetEvent: ev,
                locals: {
                    lines: _.cloneDeep(vm.stockDocument.lines),
                    pk: _.cloneDeep(vm.stockDocument.id),
                    providers: _.cloneDeep(vm.stockDocument.providers),
                    responses: _.cloneDeep(vm.stockDocument.responses)
                }
            })).then(data => {
                if (data) {
                    vm.stockDocument.responses = data;
                }
            });
        }

        function printCodes(ev) {
            vm.promise = articleService.printBarCodes(_.chain(vm.stockDocument.lines).map('article.id').compact().value()).then(data => {
                _.noop();
            }, (err)=>{
                     $mdToast.show($mdToast.simple()
                .textContent($translate.instant($translate.instant('print_barcode_issue')))
                .position("bottom left")
                .hideDelay(1000));
            });
        }
    }



    module.exports = stockDocActions;
})();
